
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsPagination',
  components: { DesignContentLayout },
  data() {
    return { currentPage: 1 };
  },
  computed: {
    series() {
      const series = [];
      for (
        let page = Math.max(this.currentPage - 3, 1);
        page <= Math.min(this.currentPage + 3, this.LAST_PAGE);
        page += 1
      ) {
        series.push(page === this.currentPage ? String(page) : page);
      }
      return series;
    },
    next() {
      return this.currentPage === this.LAST_PAGE ? null : this.currentPage + 1;
    }
  },
  created() {
    this.LAST_PAGE = 12;
  },
  methods: {
    click(page) {
      this.currentPage = page;
    }
  }
};
